import { Intent } from '../../ui';
import { AppToaster } from '../../../utils/toaster';
import { DiscardErrorCallback, ErrorIdentifier } from './error-identifier';

export const invalidCredentialsErrorIdentifier: ErrorIdentifier = (
  index: number,
  error: Error,
  discard: DiscardErrorCallback
) => {
  if (error.message.indexOf('Invalid credentials') === -1) {
    return null;
  }

  discard(error);

  AppToaster.show({
    intent: Intent.WARNING,
    icon: 'warning-sign',
    message: 'Wrong email or password, please try again.',
  });

  return false;
};
